module.exports = __webpack_public_path__ + "static/media/tra_lia_per.28d6a909.png";